// These are done here to avoid circular dependencies. This is called at the
// very top of the BlinkSDK constructor, so it's still safe to assume they
// are available at all points throughout the code.

import {merchantBuiltinFunctions} from "./Builtins.js";
import {isURLViewed} from "../../utils/PageAccessHelpers.js";
import {getQueryParam, getWindowWidth, isSmallScreen} from "../../../blinkpay/UtilsLib.js";
import {merchantVariableModule} from "./MerchantVariableModule.js";
import {getCookie, setCookie} from "../../utils/CookieHelpers.js";
import {type PanelContainerRule} from "../PanelModule.js";
import {createJourneyPanel, runBlinkAction} from "../user-journey/engine/JourneyActionRunner.js";
import {editPanel} from "../../PanelOptionsLogic";
import type {Journey} from "../user-journey/engine/Condition.js";
import {userDataModule} from "../UserDataModule.js";

// TODO @cleanup Fuck, why was this here, hidden from the panel editor.
export function initMerchantBuiltinFunctions() {
    Object.assign(merchantBuiltinFunctions, {
        ...userDataModule.exposeMerchantFunctions(),
        chooseRandom: (values: unknown[]) => {
            return values && values[Math.floor(values.length * Math.random())];
        },
        isURLViewed,
        screenWidth: getWindowWidth,
        isSmallScreen,
        getQueryParam,
        setCookie,
        getCookie,
        getVariable: (key: string) => merchantVariableModule.get(key),
        hasVariable: (key: string) => merchantVariableModule.has(key),
        setVariable: (key: string, value: unknown, scope: string) => merchantVariableModule.set(key, value, scope),
        deleteVariable: (key: string) => merchantVariableModule.delete(key),
        addVariables: (variables: Record<string, any>) => merchantVariableModule.add(variables),
        createPanel: (options: PanelContainerRule, journey?: Journey) => createJourneyPanel(options, journey),
        editPanel: (options: Record<string, any>) => editPanel(options.panel, {
            ...options,
            panel: undefined,
        }),
        runBlinkAction,
    });
}
